import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@gb-webapp/gb-app';
import { Observable } from 'rxjs';
import { Token } from '../../../interfaces/token';
import { AuthService } from '../../services/auth/auth.service';

export const PUBLIC_ENDPOINTS = [
  'cache',
  'subscribers/signup',
  'subscribers/signin',
  'subscribers/verityOTP',
  'subscribers/resendOTP',
  'subscribers/forgot',
  'subscribers/token/refreshToken',
  'inventory/check',
];

// Public translation API endpoint (no JWT token required)
export const TRANSLATE_API_URL = environment.translateApiUrl;

/**
 * JWT Authentication Interceptor
 *
 * Responsibilities:
 * - Add JWT token to authenticated requests
 * - Handle token refresh on expiration
 * - Manage authentication state
 * - Provide proper error handling
 */
export const authInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const token = inject(AuthService).token();

  // Skip JWT token for public endpoints (including translation API)
  if (
    request.url.includes(TRANSLATE_API_URL) ||
    PUBLIC_ENDPOINTS.some((url) => request.url.includes(url))
  ) {
    return next(request);
  }

  if (!token?.token) {
    return next(request);
  }

  return next(
    request.clone({
      setHeaders: {
        Authorization: `Bearer ${token?.token}`,
      },
    })
  );
};

export function mapRequestWithHeaders(
  token: Token | null,
  request: HttpRequest<unknown>
): HttpRequest<unknown> {
  return request.clone({
    setHeaders: {
      Authorization: `Bearer ${token?.token}`,
    },
  });
}
